import actions from '../../actionTypes';

export default zone => {
  return {
    type: actions.ADD_ZONE,
    zone
  };
};



// WEBPACK FOOTER //
// ./src/reducers/zones/actions/zoneAdd.js